import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import idbKeyvalAdapter from "./1_utility";
import devDebug from "../Helpers/debug";

// define the initial state
const initialState = {
  tenderAwardsCompaniesLoading: true,
  tenderAwardsShortTermLoading: true,
  tenderAwardsLongTermLoading: true,
  tenderAwardsSuppliers: true,
  tenderAwardsSuppliersLoading: true,
  tenderAwardsShortTermMarket: true,
  tenderAwardsShortTermMarketLoading: true,
  tenderAwardsCompanies: [],
  tenderAwardsShortTerm: {},
  tenderAwardsLongTerm: [],
  tenderAwardsMetric: "total_amount",
  user: {},
  userLoaded: false,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useTenderAwardsStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ------------------- TENDER AWARDS --------------
      setTenderAwardsMetric: (payload) =>
        set((state) => {
          state.tenderAwardsMetric = payload;
        }),
      setTenderAwardsShortTermMarket: (payload) =>
        set((state) => {
          state.tenderAwardsShortTermMarket = payload;
        }),
      setTenderAwardsShortTermMarketLoading: (payload) =>
        set((state) => {
          state.tenderAwardsShortTermMarketLoading = payload;
        }),
      setTenderAwardsSuppliers: (payload) =>
        set((state) => {
          state.tenderAwardsSuppliers = payload;
        }),
      setTenderAwardsSuppliersLoading: (payload) =>
        set((state) => {
          state.tenderAwardsSuppliersLoading = payload;
        }),
      setTenderAwardsCompanies: (payload) =>
        set((state) => {
          state.tenderAwardsCompanies = payload;
        }),
      setTenderAwardsShortTerm: (payload) =>
        set((state) => {
          state.tenderAwardsShortTerm = payload;
        }),
      setTenderAwardsLongTerm: (payload) =>
        set((state) => {
          state.tenderAwardsLongTerm = payload;
        }),
      setTenderAwardsCompaniesLoading: (payload) =>
        set((state) => {
          state.tenderAwardsCompaniesLoading = payload;
        }),
      setTenderAwardsShortTermLoading: (payload) =>
        set((state) => {
          state.tenderAwardsShortTermLoading = payload;
        }),
      setTenderAwardsLongTermLoading: (payload) =>
        set((state) => {
          state.tenderAwardsLongTermLoading = payload;
        }),
      resetState: () => {
        useTenderAwardsStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: "tenderAwards",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[tenderAwardsStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[tenderAwardsStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[tenderAwardsStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[tenderAwardsStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[tenderAwardsStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[tenderAwardsStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[tenderAwardsStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[tenderAwardsStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[tenderAwardsStore] Error during rehydration. Store name: "tenderAwardsStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[tenderAwardsStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
